import React, { useEffect, useState } from 'react';
import { useFetch, useNotifications } from "@engenharia/react-tools";
import { CRow, CButton, CCard, CCardBody, CCardTitle, CForm, CFormGroup, CInput, CInputGroup, CInputGroupAppend, CLabel } from '@coreui/react';

const initialState =
{
  "Email.SMTP.Endereco": "",
  "Email.SMTP.Porta": "",
  "Email.SMTP.Usuario": "",
  "Email.SMTP.Senha": "",
  "Email.SMTP.SSL": false,
  "Email.De": ""
}

const EmailConfigs = () => {
  const { get, post } = useFetch()
  const { success, danger } = useNotifications();
  const [state, setState] = useState(initialState)
  const [testMail, setTestmail] = useState('')

  useEffect(() => {
    get('/configs',
      res => {
        if (res.sucesso && res.dados.length) {
          let state = {
            "Email.SMTP.Endereco": res.dados.find(c => c.chave === "Email.SMTP.Endereco").valor,
            "Email.SMTP.Porta": res.dados.find(c => c.chave === "Email.SMTP.Porta").valor,
            "Email.SMTP.Usuario": res.dados.find(c => c.chave === "Email.SMTP.Usuario").valor,
            "Email.SMTP.Senha": res.dados.find(c => c.chave === "Email.SMTP.Senha").valor,
            "Email.SMTP.SSL": res.dados.find(c => c.chave === "Email.SMTP.SSL").valor === 'true',
            "Email.De": res.dados.find(c => c.chave === "Email.De").valor
          }
          setState(state)
        }
      },
      err => {
        console.log(err)
      }
    )
  }, [get])

  const handleChange = ({ target }) => {
    const { name, value } = target;
    setState({ ...state, [name]: value });
  }

  const handleSave = () => {
    let array = [];
    Object.keys(state).forEach(prop => array.push({ chave: prop, valor: state[prop] }));
    post('/proc/portal.persistir_configuracoes', { configuracao: array }, res => success(res.dados),
      err => {
        danger('Falha ao persistir as configurações.');
        console.log(err);
      });
  }

  const handleTest = () => {
    post('/email', { template: 'Email.Teste', para: testMail }, res => {
      if (res.sucesso) success('E-mail de teste enviado com sucesso')
    }, err => {
      console.log(err)
      danger('Falha ao enviar o e-mail de teste')
    })
  }

  return (
    <CCard>
      <CCardBody>
        <CCardTitle>E-mail</CCardTitle>
        <p className="card-text">Configurar servidor personalizado para envio de e-mails</p>

        <CForm>
          <CRow>
            <CFormGroup className="col-md-6">
              <CLabel>Servidor SMTP:</CLabel>
              <CInput name="Email.SMTP.Endereco" value={state["Email.SMTP.Endereco"]} onChange={handleChange} required />
            </CFormGroup>

            <CFormGroup className="col-md-6">
              <CLabel>Porta do servidor SMTP:</CLabel>
              <CInput name="Email.SMTP.Porta" value={state["Email.SMTP.Porta"]} onChange={handleChange} required />
            </CFormGroup>
          </CRow>

          <CRow>
            <CFormGroup className="col-md-6">
              <CLabel>Usuário:</CLabel>
              <CInput name="Email.SMTP.Usuario" value={state["Email.SMTP.Usuario"]} onChange={handleChange} required />
            </CFormGroup>

            <CFormGroup className="col-md-6">
              <CLabel>Senha:</CLabel>
              <CInput name="Email.SMTP.Senha" value={state["Email.SMTP.Senha"]} onChange={handleChange} required />
            </CFormGroup>
          </CRow>

          <CRow>
            <CFormGroup className="col-md-12">
              <CLabel>Remetente:</CLabel>
              <CInput name="Email.De" value={state["Email.De"]} onChange={handleChange} required />
            </CFormGroup>
          </CRow>

          <CRow>
            <CFormGroup className="col-md-12">
              <div className="form-check">
                <input
                  id="email-ssl"
                  className="form-check-input"
                  type="checkbox"
                  name="Email.SMTP.SSL"
                  checked={state["Email.SMTP.SSL"]}
                  onChange={({ target }) => handleChange({ target: { name: target.name, value: target.checked } })}
                />
                <label htmlFor="email-ssl" className="form-check-label">Utiliza SSL</label>
              </div>
            </CFormGroup>
          </CRow>

          <div className="d-flex">
            <CButton color="primary" className="ms-auto" onClick={handleSave}>Salvar</CButton>
            <CButton color="outline-dark" className="ms-1" onClick={() => setState(initialState)}>Limpar</CButton>
          </div>

          <hr />
          <p className="card-text">Testar o envio de e-mails utilizando as configurações salvas</p>
          <CFormGroup>
            <CLabel>Para:</CLabel>
            <CInputGroup>
              <CInput type="email" value={testMail} onChange={({ target }) => setTestmail(target.value)} />
              <CInputGroupAppend>
                <CButton color="outline-primary" onClick={handleTest}>Enviar</CButton>
              </CInputGroupAppend>
            </CInputGroup>
          </CFormGroup>

        </CForm>
      </CCardBody>
    </CCard>
  );
};

export default EmailConfigs;